
import { UseFormReturn } from "react-hook-form";
import { MembershipFormData } from "../types";

export const resetFormToInitialState = (form: UseFormReturn<MembershipFormData>) => {
  console.log("Resetting form to initial state...");
  
  // Reset the form with initial values
  form.reset({
    applicationDate: new Date(),
    termsAccepted: false,
    businessName: "",
    email: "",
    firstName: "",
    lastName: "",
    address: {
      street1: "",
      street2: "",
      city: "",
      postalCode: "",
    },
    businessAddress: {
      street1: "",
      street2: "",
      city: "",
      postalCode: "",
    },
    mobileNumber: {
      areaCode: "",
      number: "",
    },
    businessNumber: {
      areaCode: "",
      number: "",
    },
    membershipType: undefined,
    currentPotatoArea: undefined,
    totalPotatoArea: undefined,
    plannedPotatoArea: undefined,
    signature: "",
    captchaToken: "", // Reset the captcha token
  });

  // Force the form to update
  Object.keys(form.getValues()).forEach(key => {
    form.trigger(key as keyof MembershipFormData);
  });
  
  // Dispatch a custom event to notify signature component to reset
  const resetSignatureEvent = new CustomEvent('resetSignature');
  document.dispatchEvent(resetSignatureEvent);
  
  console.log("Form reset completed, including signature box");
};
